{
  "metadata": {
    "id": "arctic-dark",
    "name": "Arctic",
    "description": "Собственная тема Synth «Arctic» (dark)",
    "author": "Synth",
    "version": "2.0.0",
    "variant": "dark",
    "tags": [
      "dark",
      "synth",
      "own"
    ],
    "source": {
      "file": "tools/lib/make_themes.py",
      "project": "synth",
      "url": null,
      "upstreamFile": null,
      "license": "собственная (Synth)",
      "authoring": "tools/lib/make_themes.py"
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 24.3,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.471,
      "paletteMaxS": 0.51,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 4.2,
      "surfacesTarget": 4.0,
      "surfacesRaisedTarget": 5.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 20.1,
      "syntaxVsTextMinDeltaE": 11.2,
      "chartsMinDeltaE": 22.2,
      "textSeparationDeltaE": 24.1,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "keyword",
          "b": "function",
          "deltaE": 17.5
        },
        {
          "a": "keyword",
          "b": "type",
          "deltaE": 13.9
        }
      ],
      "modeLabel": "dark",
      "modeFromLuminance": "dark",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#22D3EE",
      "hover": "#3dd8f0",
      "active": "#4edcf1",
      "foreground": "#000000",
      "muted": "#22d3ee80",
      "emphasis": "#22D3EE"
    },
    "surface": {
      "background": "#0B1220",
      "foreground": "#D6E4F0",
      "muted": "#1f2836",
      "mutedForeground": "#8fa6bf",
      "elevated": "#28313f",
      "elevatedForeground": "#D6E4F0",
      "raised": "#414b59",
      "raisedForeground": "#D6E4F0",
      "overlay": "#0b1220cc",
      "subtle": "#161e2d"
    },
    "interactive": {
      "border": "#434d5c",
      "borderHover": "#444d5a",
      "borderFocus": "#22D3EE",
      "selection": "#d6e4f029",
      "selectionForeground": "#D6E4F0",
      "focus": "#22d3ee59",
      "focusRing": "#22d3ee61",
      "cursor": "#f1f7fd",
      "hover": "#d6e4f01c",
      "active": "#d6e4f029"
    },
    "status": {
      "error": "#FB7185",
      "errorForeground": "#000000",
      "errorBackground": "#fb718524",
      "errorBorder": "#fb718573",
      "warning": "#FBBF24",
      "warningForeground": "#000000",
      "warningBackground": "#fbbf2424",
      "warningBorder": "#fbbf2473",
      "success": "#34D399",
      "successForeground": "#000000",
      "successBackground": "#34d39924",
      "successBorder": "#34d39973",
      "info": "#38BDF8",
      "infoForeground": "#000000",
      "infoBackground": "#38bdf824",
      "infoBorder": "#38bdf873"
    },
    "pr": {
      "open": "#34D399",
      "draft": "#8fa6bf",
      "blocked": "#FBBF24",
      "merged": "#2563EB",
      "closed": "#FB7185"
    },
    "syntax": {
      "base": {
        "background": "#2c3543",
        "foreground": "#D6E4F0",
        "comment": "#bc8fb8",
        "keyword": "#7DD3FC",
        "string": "#5EEAD4",
        "number": "#C4B5FD",
        "function": "#22D3EE",
        "variable": "#D6E4F0",
        "type": "#93C5FD",
        "operator": "#94A3B8"
      },
      "tokens": {
        "commentDoc": "#bc8fb8",
        "stringEscape": "#94A3B8",
        "keywordImport": "#7DD3FC",
        "storageModifier": "#7DD3FC",
        "functionCall": "#22D3EE",
        "method": "#22D3EE",
        "variableProperty": "#22D3EE",
        "variableOther": "#D6E4F0",
        "variableGlobal": "#C4B5FD",
        "variableLocal": "#94A3B8",
        "parameter": "#D6E4F0",
        "constant": "#C4B5FD",
        "class": "#93C5FD",
        "className": "#93C5FD",
        "interface": "#93C5FD",
        "struct": "#93C5FD",
        "enum": "#93C5FD",
        "typeParameter": "#93C5FD",
        "namespace": "#93C5FD",
        "module": "#7DD3FC",
        "tag": "#7DD3FC",
        "jsxTag": "#7DD3FC",
        "tagAttribute": "#22D3EE",
        "tagAttributeValue": "#5EEAD4",
        "boolean": "#C4B5FD",
        "decorator": "#7DD3FC",
        "label": "#22D3EE",
        "regexp": "#5EEAD4"
      }
    },
    "charts": {
      "series": [
        "#22D3EE",
        "#38BDF8",
        "#34D399",
        "#FBBF24",
        "#FB7185"
      ]
    },
    "chat": {
      "background": "#0B1220",
      "userMessage": "#D6E4F0",
      "userMessageBackground": "#28313f",
      "assistantMessage": "#D6E4F0",
      "assistantMessageBackground": "#1f2836",
      "timestamp": "#8fa6bf",
      "divider": "#434d5c",
      "typing": "#8fa6bf"
    },
    "loading": {
      "spinner": "#22D3EE",
      "spinnerTrack": "#1f2836",
      "skeleton": "#1f2836",
      "shimmer": "#36404d"
    },
    "tools": {
      "background": "#1f2836",
      "border": "#434d5c",
      "headerHover": "#343e4c",
      "icon": "#22D3EE",
      "title": "#D6E4F0",
      "description": "#8fa6bf",
      "edit": {
        "added": "#34D399",
        "addedBackground": "#34d39924",
        "removed": "#FB7185",
        "removedBackground": "#fb718524",
        "modified": "#38BDF8",
        "modifiedBackground": "#38bdf824",
        "lineNumber": "#8fa6bf"
      }
    },
    "markdown": {
      "heading1": "#D6E4F0",
      "heading2": "#D6E4F0",
      "heading3": "#D6E4F0",
      "heading4": "#D6E4F0",
      "link": "#22D3EE",
      "linkHover": "#3dd8f0",
      "inlineCode": "#5EEAD4",
      "inlineCodeBackground": "#1f2836",
      "blockquote": "#8fa6bf",
      "blockquoteBorder": "#434d5c",
      "listMarker": "#22d3eebf",
      "bold": "#D6E4F0",
      "italic": "#d6e4f0e6",
      "strikethrough": "#8fa6bf",
      "hr": "#434d5c"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#bf5042",
        "foreground": "#ffffff",
        "contrast": 4.73
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#d4ab94",
        "foreground": "#000000",
        "contrast": 10.05
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#c3984d",
        "foreground": "#000000",
        "contrast": 7.92
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#b4c755",
        "foreground": "#000000",
        "contrast": 11.24
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#bed798",
        "foreground": "#000000",
        "contrast": 13.36
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#54c550",
        "foreground": "#000000",
        "contrast": 9.48
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#58ba7b",
        "foreground": "#000000",
        "contrast": 8.72
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#93dcc2",
        "foreground": "#000000",
        "contrast": 13.26
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#52b6c4",
        "foreground": "#000000",
        "contrast": 8.85
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#4992c0",
        "foreground": "#000000",
        "contrast": 6.16
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#3f67bb",
        "foreground": "#ffffff",
        "contrast": 5.43
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#9790d0",
        "foreground": "#000000",
        "contrast": 7.22
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#7049b1",
        "foreground": "#ffffff",
        "contrast": 6.41
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#d88ed7",
        "foreground": "#000000",
        "contrast": 8.77
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#bf48a5",
        "foreground": "#000000",
        "contrast": 4.69
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#bf466f",
        "foreground": "#ffffff",
        "contrast": 4.86
      }
    ]
  }
}
